import { Form } from '@kanda-libs/ks-component-ts';
import { Details } from 'pages/CreateJob/components';
import * as JobExtraDetails from 'pages/CreateJob/Desktop/components/Pages/Form/components/JobExtraDetails';
import type { FunctionComponent } from 'react';
import Page from '../../Page';
import Container from './ExtraDetails-container';

const ExtraDetails: FunctionComponent = function () {
  return (
    <Container>
      {({ form, onSubmit, nextButtonProps }) => (
        <Form id="create-job-customer-mobile" form={form} onSubmit={onSubmit}>
          <Page stickyHeader nextButtonProps={nextButtonProps}>
            <div className="flex flex-col gap-y-4">
              <Details.ChangesBanner />
              <JobExtraDetails.Info />
              <JobExtraDetails.Fields />
            </div>
          </Page>
        </Form>
      )}
    </Container>
  );
};

export default ExtraDetails;
